"use strict";

import { c as _c } from "react/compiler-runtime";
import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const contactNumbersContext = /*#__PURE__*/createContext(null);
export const useContactNumbers = () => {
  const contextValue = useContext(contactNumbersContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Please have a  <ContactNumbersProvilder /> set in your tree") : invariant(false) : void 0;
  return contextValue;
};
export const ContactNumbersProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      successContactNumber: "07 5612 5347",
      ordersContactNumber: "02 5300 2825",
      agCustomerContactNumber: "1300 655 661",
      wexContactNumber: "1300 319 886",
      ampolContactNumber: "1300 656 014",
      smsFromNumberForTransactional: "0480 018 336"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  t1 = t2;
  const contactNumbersContextValue = t1;
  let t3;
  if ($[1] !== children) {
    t3 = /*#__PURE__*/_jsx(contactNumbersContext.Provider, {
      value: contactNumbersContextValue,
      children: children
    });
    $[1] = children;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};